import React, { useState, useEffect, useRef } from "react";
import { FiSearch } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";
import ToastrService from "../../services/toastService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Dropdown, ButtonGroup } from "react-bootstrap";
import { useGetUsersByRoleMutation } from "./Api";
import Loader from "../loader/loader";
import Pagination from "../Pagination/Pagination";


const ViewUsers = () => {

    // const { id } = useParams()
    const location = useLocation();
    const id = location.state?.id;

    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);


    const [getUsersApi, { isLoading }] = useGetUsersByRoleMutation()


    const [activeUsersCount, setActiveUsersCount] = useState(0)
    const [inActiveUsersCount, setInActiveUsersCount] = useState(0)
    const [unconfirmedUsersCount, setUnconfirmedUsersCount] = useState(0)
    const [deletedUsersCount, setDeletedUsersCount] = useState(0)
    const [allUsersCount, setAllUsersCount] = useState(0)

    const navigate = useNavigate();

    const [statusFilter, setStatusFilter] = useState("All");
    const [isOpen, setIsOpen] = useState(false);


    const options = [
        { label: `All (${allUsersCount})`, value: "All" },
        { label: `Active Users (${activeUsersCount})`, value: "Active" },
        { label: `Inactive Users (${inActiveUsersCount})`, value: "Inactive" },
        { label: `Unconfirmed Users (${unconfirmedUsersCount})`, value: "Unconfirmed" },
        { label: `Deleted Users (${deletedUsersCount})`, value: "Deleted" },
    ];

    const UserStatusBadge = ({ status }) => {
        let badgeClass = "";

        switch (status.toLowerCase()) {
            case "active":
                badgeClass = "bg-success"; // green
                break;
            case "inactive":
                badgeClass = "bg-secondary"; // gray
                break;
            case "unconfirmed":
                badgeClass = "bg-warning text-dark"; // yellow
                break;
            case "deleted":
                badgeClass = "bg-danger"; // red
                break;
            default:
                badgeClass = "bg-light text-dark";
        }

        return <span className={`badge ${badgeClass}`}>{status}</span>;
    };



    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => clearTimeout(timer);

    }, [search]);



    useEffect(() => {
        getUsers()
    }, [currentPage, rowsPerPage, debouncedSearch, statusFilter]);


    const getUsers = async () => {
        try {
            const response = await getUsersApi({
                page: currentPage,
                limit: rowsPerPage,
                filter: debouncedSearch.trim(),
                status: statusFilter,
                roleId: id
            })

            const usersData = response?.data?.data.users || [];
            const pagination = response?.data?.data.pagination || {};

            setUsers(usersData);
            setTotalRecords(pagination.total || 0);
            setTotalPages(pagination.totalPages || 1);
            setActiveUsersCount(response.data.data.counts.active || 0);
            setInActiveUsersCount(response.data.data.counts.inactive || 0);
            setUnconfirmedUsersCount(response.data.data.counts.unconfirmed || 0);
            setDeletedUsersCount(response.data.data.counts.deleted || 0);
            setAllUsersCount(response.data.data.counts.all || 0);
        } catch (err) {
            setUsers([]);
            setTotalRecords(0);
            setTotalPages(1);
            console.log(err, 'err')
        }
    }



    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);


    const getPageNumbers = () => {
        const pages = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);

            if (currentPage > 3) {
                pages.push("...");
            }

            let start = Math.max(2, currentPage - 1);
            let end = Math.min(totalPages - 1, currentPage + 1);

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (currentPage < totalPages - 2) {
                pages.push("...");
            }

            pages.push(totalPages);
        }

        return pages;
    };

    const toTitleCase = (text) => {
        if (!text) return "";
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    };

    return (

        <div>
            {isLoading ? <Loader /> :
                <div>

                    {/* Header */}

                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <ul className="breadcrumb mb-0">
                                <li className="breadcrumb-item">Roles & Permission Management</li>
                                <li className="breadcrumb-item active">Profile</li>
                            </ul>
                        </div>
                    </div>

                    <div className="main-content">

                        <div className="row">

                            <div className="p-6">

                                {/* Title */}

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h3 className="h4 mb-1 drawer-header">
                                            Users ({totalRecords})
                                        </h3>
                                        <p className="mb-0 text-muted">
                                            Manage All Users.
                                        </p>
                                    </div>
                                </div>


                                <div className="card p-3 mb-4">

                                    {/* Toolbar */}
                                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mb-1">

                                        {/* Left Tabs */}
                                        <ul className="nav pl-2">
                                            <li className="nav-item">
                                                <a className="nav-link active tab-primary">
                                                    Users
                                                </a>
                                            </li>
                                        </ul>

                                        {/* Right controls */}
                                        <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2">



                                            <div
                                                className="d-flex flex-column flex-grow-1 flex-lg-grow-0"
                                            // style={{ flex: "0 0 25%", minWidth: "150px" }}
                                            >
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search"
                                                    value={search}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setSearch(value);
                                                        setCurrentPage(1); // reset to first page when searching
                                                    }}
                                                />
                                            </div>

                                            <div
                                                className="d-flex flex-column flex-grow-1 flex-lg-grow-0"
                                                style={{ flex: "0 0 20%", minWidth: "200px" }}
                                            >
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={statusFilter}
                                                    onChange={(e) => {
                                                        setStatusFilter(e.target.value);
                                                        setCurrentPage(1);
                                                    }}
                                                >
                                                    {options.map((opt) => (
                                                        <option key={opt.value} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                    </div>

                                    {/* Table */}

                                    <div className="table-responsive">

                                        <table className="table table-hover mb-0">

                                            <thead>
                                                <tr>
                                                    <th>Full Name</th>
                                                    <th>Email Address</th>
                                                    <th>Employee ID</th>
                                                    <th>FLEXZ ID</th>
                                                    <th>Primary Role</th>
                                                    {/* <th>Secondary Role</th> */}
                                                    <th>User Status</th>
                                                </tr>
                                            </thead>

                                            <tbody>


                                                {!isLoading && users.length === 0 && (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">
                                                            No data found
                                                        </td>
                                                    </tr>
                                                )}

                                                {!isLoading && users.map((user, index) => (

                                                    <tr key={index}>

                                                        <td>
                                                            {toTitleCase(user.first_name)} {toTitleCase(user.last_name)}
                                                        </td>

                                                        <td>{user.email}</td>

                                                        <td > {user.employee_id}</td>
                                                        <td>{user.flexz_id}</td>

                                                        <td >
                                                            {toTitleCase(user['primaryRole.role_displayname'])}
                                                        </td>
                                                        {/* <td >
                                                    {toTitleCase(user['secondaryRole.role_displayname'])}
                                                </td> */}
                                                        <td>
                                                            <UserStatusBadge status={toTitleCase(user.employee_status)} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                                            <div className="d-flex align-items-center gap-1 small">

                                                <span>Show</span>

                                                <select
                                                    className="form-select form-select-sm page-size-select"
                                                    value={rowsPerPage}
                                                    onChange={(e) => {
                                                        setRowsPerPage(Number(e.target.value));
                                                        setCurrentPage(1);
                                                    }}
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={15}>15</option>
                                                </select>

                                                <span>entries</span>

                                            </div>

                                            <div className="small text-muted">
                                                Showing {startEntry} to {endEntry} of {totalRecords} entries
                                            </div>

                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                maxPagesToShow={rowsPerPage}
                                                onPageChange={(page) => setCurrentPage(page)}
                                            />
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>

                </div>
            }
        </div>

    );
};

export default ViewUsers;  